import axios from 'axios'
import uuidv4 from 'uuid/v4'
import { Message, MessageBox } from 'element-ui'
import { getToken, setToken } from '@/utils/auth'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: '',
  timeout: 3000,
  responseType: 'json',
  withCredentials: false
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers['Request-Id'] = uuidv4()
  config.headers['accessToken'] = getToken('accessToken') || ''
  config.headers['refreshToken'] = getToken('refreshToken') || ''
  return config
}, error => {
  console.log('[DEBUG]', error)
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    const { data, headers, config } = response

    if (config.responseType !== 'json') return response

    if (data.errorCode === 0) { // 请求失败
      const { accesstoken, refreshtoken } = headers // 解析后的字段全变成小写了
      accesstoken && setToken('accessToken', accesstoken)
      refreshtoken && setToken('refreshToken', refreshtoken)
      return response
    } else {
      const error = new Error('Response error')
      error.response = response
      return Promise.reject(error)
    }
  },
  error => {
    console.log('[DEBUG]', error)
    const { data = {}, config = {} } = error.response || {}

    if (config.responseType === 'json') {
      if (data.errorCode === 40000001) { // 登录过期
        setToken('accessToken', '')
        setToken('refreshToken', '')
        MessageBox.confirm('你的登录已过期，可以取消继续留在该页面，或者重新登录', '重新登录？', {
          type: 'warning',
          showClose: false,
          cancelButtonText: '取消',
          confirmButtonText: '重新登录'
        }).then(() => {
          store.dispatch('logout').then(() => {
            router.push({ name: 'Login' })
          })
        }).catch(() => {
          // No handler
        })
      } else {
        Message({
          type: 'error',
          center: !true,
          message: data.message || error.message,
          duration: 5 * 1000
        })
      }
    }

    return Promise.reject(error)
  }
)

export default service
